// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XnvwxT88BoOhpIYGkHxV {
  border: 1px solid #ddd;
}
._075TBDCZyoAvxo9_Jc3g {
  border-bottom: none;
}
.VbTsLQm1AC0KWd5rkE62 {
  border-bottom: 1px solid #ddd;
  padding: 5px;
}
.Zn_Tz86RJc_GcP7K3SH3 {
  padding: 5px;
}
.a1pEZ9eeNNY49uurqn0B {
  background-color: #fafafa !important;
  width: 170px;
}
.FjwslpSvlKWPmkIIm5_D {
  color: #FF8A00;
  border-color: #FF8A00;
}
.q1O1us7Od0LktX8V1p1F {
  color: green;
  border-color: green;
}
.gyrDuHG11H3RKO2HHnsA {
  color: red;
  border-color: red;
}
.yldMoeYzOBK1RuqPyV7a {
  width: 120px;
}
.wnOyMJy8FMlx3l0aKSEn {
  color: #1677ff;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/RightPanel/UnitPanel/components/common/styles.module.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;AAEA;EACE,mBAAA;AAAF;AAGA;EACE,6BAAA;EACA,YAAA;AADF;AAIA;EACE,YAAA;AAFF;AAKA;EACE,oCAAA;EACA,YAAA;AAHF;AAMA;EACE,cAAA;EACA,qBAAA;AAJF;AAOA;EACE,YAAA;EACA,mBAAA;AALF;AAQA;EACE,UAAA;EACA,iBAAA;AANF;AASA;EACE,YAAA;AAPF;AAUA;EACE,cAAA;AARF","sourcesContent":[".cardContainer {\n  border: 1px solid #ddd;\n}\n\n.noBottomBorder {\n  border-bottom: none;\n}\n\n.cardHeader {\n  border-bottom: 1px solid #ddd;\n  padding: 5px;\n}\n\n.cardContent {\n  padding: 5px;\n}\n\n.rowTitle {\n  background-color: #fafafa !important;\n  width: 170px;\n}\n\n.warn {\n  color: #FF8A00;\n  border-color: #FF8A00;\n}\n\n.successed {\n  color: green;\n  border-color: green;\n}\n\n.error {\n  color: red;\n  border-color: red;\n}\n\n.numberInput {\n  width: 120px;\n}\n\n.manualInputRow {\n  color: #1677ff;\n}\n\n.msgContainer {\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `XnvwxT88BoOhpIYGkHxV`,
	"noBottomBorder": `_075TBDCZyoAvxo9_Jc3g`,
	"cardHeader": `VbTsLQm1AC0KWd5rkE62`,
	"cardContent": `Zn_Tz86RJc_GcP7K3SH3`,
	"rowTitle": `a1pEZ9eeNNY49uurqn0B`,
	"warn": `FjwslpSvlKWPmkIIm5_D`,
	"successed": `q1O1us7Od0LktX8V1p1F`,
	"error": `gyrDuHG11H3RKO2HHnsA`,
	"numberInput": `yldMoeYzOBK1RuqPyV7a`,
	"manualInputRow": `wnOyMJy8FMlx3l0aKSEn`
};
export default ___CSS_LOADER_EXPORT___;
